import React from "react";
import CalendarEventCard from "./CalendarEventCard";
import type { CalendarBlockData } from "./types";
import CalendarIcon from "../../icons/Calendar";
import classNames from "classnames";

function CalendarBlock({ events, description, calendarLink, className }: CalendarBlockData) {
  return (
    <section className={classNames("calendar-block", "shaded-block", className)}>
      <div className="calendar-header">
        <div>
          <h2>Upcoming Events</h2>
          <p>{description}</p>
        </div>
        <a 
          className="btn-tertiary" 
          href="http://uwc.211ct.org/get-help/calendar-form/" 
          target="_blank" 
          rel="noreferrer"
        >
          Submit an event
        </a>
      </div>
      <div className="upcoming-events">
        {!events.length ? (
          <p>There are no scheduled events at this time.</p>
        ) : (
          <ul>
            {events.slice(0, 4).map((event) => (
              <li key={event.id}>
                <CalendarEventCard {...event} />
              </li>
            ))}
          </ul>
        )}
      </div>
      <a className="view-calendar-link" href={calendarLink} target="_blank" rel="noreferrer">
        View the full calendar →
      </a>
    </section>
  );
}

export default CalendarBlock;
